export class ContactoClase {
    public codcli: string;
    public codcont: number;
    public clase: number;
    public codigo: string;
    public vreal: number;
    public vstrg: string;
    public vchar: string;
    public vdate: string;
    public vtime: string;
    public ventero: number;
    public codusercrea: string;
    public coduseractu: string;
    public fcreac: string;
    public factua: string;
    public usuari: string;
    public claseDesc: string;
    public codigoDesc: string;
}